<template>
  <div>
    <MTop :title="title" />
    <div style="padding:10px 20px;">
      <el-input
        @focus="blurHandle"
        @blur="isShow = true"
        class="tac"
        clearable
        v-model="value"
        placeholder="请输入名称/标签/简介"
      >
        <el-button @click="submitSearch" slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div v-if="!value && isShow">
      <ul class="list_ul">
        <li
          :class="[activeId == item.id ?'activedLi':'']"
          @click="selectTab(item.id)"
          v-for="item in topArray"
          :key="item.id"
        >
          <div style="font-size:20px;" :class="['iconfont', item.icon,item.color]"></div>

          <!-- <el-image style="width:50px;height:48px;" :src="item.src"></el-image> -->
          <span style="font-weight: bold;font-size:14px;">{{item.name}}</span>
        </li>
      </ul>
    </div>
    <!-- 主体 -->
    <div v-show="isShow">
      <router-view @func="getName" :videoId="videoTypeId" :searchVlaue="value" ref="child-name"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      isShow: true,
      title: "视频列表",
      topArray: [
        {
          id: 1,
          src: require("../../assets/img/icon/play.png"),
          name: "成片库",
          icon: "iconshipin",
          color: "one"
        },
        {
          id: 0,
          src: require("../../assets/img/icon/sucai.png"),
          name: "素材库",
          icon: "iconwenjianjia",
          color: "two"
        },
        {
          id: 2,
          src: require("../../assets/img/icon/size.png"),
          name: "高级搜索",
          icon: "iconsousuo",
          color: "three"
        }
      ],
      value: "",
      activeId: -1,
      videoTypeId: ""
    };
  },
  methods: {
    getName: function(data) {
      this.title = data;
    },
    blurHandle: function() {
      this.$router.push("/mobvideolist");
      this.isShow = false;
    },

    submitSearch: function() {
      this.$store.state.page = 1;
      this.childFun();
    },
    selectTab: function(params) {
      var that = this;
      console.log(params);
      this.activeId = params;

      if (params == 2) {
        // params = "";
        this.$router.push("/highsearch");
        return;
      } else {
        this.videoTypeId = params;
        console.log(this.videoTypeId);
        this.$router.push("/mobvideolist");
        setTimeout(function() {
          that.childFun();
        }, 300);
      }
      //   this.checkedList();
    },
    childFun: function() {
      //   console.log(this.$refs["child-name"]);
      this.$refs["child-name"].searchButtonVideoList();
    }
  },
  mounted: function() {},
  beforeDestroy:function(){
      this.$store.commit("clearSearchObj");
  }
};
</script>

<style lang="scss" scoped>
.one {
  color: #2d98fe;
}
.two {
  color: #2cd9c5;
}
.three {
  color: #00aaff;
}
.activedLi {
  border: 2px solid red !important;
}
.list_ul {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: #fff;
  padding: 15px;
  li {
    border: 1px solid #eaeaea;
    display: flex;
    flex-direction: column;
    padding: 5px 25px;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    // font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/video.vue